import * as z from 'zod'
import Rosettas from '../lib/rosettas'

export {
  IndexZod,
  IDTextualZod,
  IDTextualOpcionalZod,
  IDNumericoOpcionalZod,
  IDNumericoZod,
  NumeroZod,
  NumeroOpcionalZod,
  NumeroONullZod,
  NumeroOCeroZod,
  StringZod,
  StringOpcionalZod,
  StringONull,
  URLZod,
  URLOpcionalZod,
  BooleanOVerdaderoZod,
  BooleanOpcionalZod,
  MontoZod,
  MontoPositivoZod,
  MonedasZod,
  PrecioOpcionalZod,
  ArrayCualquieraONada,
  EsArray,
  EmailZod,
  EmailOpcionalZod,
  PassZod,
  PassNuevoZod
} from '@comun/zodComun'

const i18n = Rosettas.crear({
  EmailNecesario: {
    es: 'Email necesario',
    en: 'Email required',
    pt: 'Email necessário'
  },
  EmailInvalido: {
    es: 'Email inválido',
    en: 'Invalid email',
    pt: 'Email inválido'
  },
  PassNecesario: {
    es: 'Contraseña necesaria',
    en: 'Password required',
    pt: 'Senha necessária'
  },
  PassMuyCorto: {
    es: 'Contraseña muy corta',
    en: 'Password too short',
    pt: 'Senha muito curta'
  },
  PassNuevoMuyCorto: {
    es: 'Contraseña nueva muy corta',
    en: 'New password too short',
    pt: 'Nova senha muito curta'
  }
})

export const InputEmailZod = z.preprocess(v => typeof v === 'string' ? v : undefined, z.email({ message: i18n('EmailInvalido') }))

export const InputPassZod = z.string().min(2, i18n('PassMuyCorto'))

export const InputPassNuevoZod = z.string().min(6, i18n('PassNuevoMuyCorto'))

function EmailConCatch(puedeSerEmail: string) {
  try {
    return z.email().parse(puedeSerEmail)
  }
  catch (e: unknown) {
    consolo.warn('email invalido', e)
    return undefined
  }
}

export const EmailOIndefZod = z.preprocess(
  v => (typeof v === 'string' ? EmailConCatch(v.trim()) : undefined),
  z.email().optional()
)

export const NotaZod = z.union([
  z.literal(1),
  z.literal(2),
  z.literal(3),
  z.literal(4),
  z.literal(5)
])
export type Nota = z.infer<typeof NotaZod>

